module.exports = __webpack_public_path__ + "static/media/u-bahn~gpXlehLX.ea9f3635.svg";